import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/contact/ContactView.tsx");
